import { render, staticRenderFns } from "./ImmovablesCreate.vue?vue&type=template&id=2896222e&"
import script from "./ImmovablesCreate.vue?vue&type=script&lang=js&"
export * from "./ImmovablesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports